import { X } from "lucide-react";

export default function ProfileSessionMailModal({
  mailSession,
  onClose,
  buildSessionEmailTemplate,
  copyToClipboard,
  getGameName,
}) {
  const { subject, body } = buildSessionEmailTemplate(mailSession);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="bg-white border border-slate-200 rounded-2xl max-w-3xl w-full max-h-[85vh] flex flex-col shadow-xl">

        {/* Header */}
        <div className="px-5 py-4 border-b border-slate-200 flex items-start justify-between gap-3">
          <div>
            <h4 className="text-sm font-semibold text-slate-900">
              Mail à envoyer aux participants
            </h4>
            <p className="text-xs text-slate-500 mt-0.5">
              Code session : <span className="font-mono text-indigo-600">{mailSession.code}</span>
              {" "}· {getGameName(mailSession.gameId)}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 text-slate-400 hover:text-slate-600 transition"
            aria-label="Fermer"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4 overflow-y-auto flex-1">

          {/* Instructions */}
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
            <p className="text-xs font-medium text-slate-700 mb-2">Comment envoyer ce mail</p>
            <ol className="text-xs text-slate-600 space-y-1 list-decimal pl-4">
              <li>Copiez l'objet et le corps du mail ci-dessous.</li>
              <li>Ouvrez votre messagerie (Outlook, Gmail…).</li>
              <li>Collez le contenu, ajoutez les destinataires et envoyez.</li>
            </ol>
            <p className="mt-2 text-[11px] text-slate-400">
              Ce bouton ne fait pas l'envoi automatiquement — il prépare le contenu à copier-coller.
            </p>
          </div>

          {/* Contenu du mail */}
          <div className="border border-slate-200 rounded-xl p-4 bg-slate-50 space-y-3">
            <div className="flex items-center justify-between">
              <p className="text-xs font-semibold text-slate-900">Contenu du mail</p>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => copyToClipboard(subject, "Objet copié.")}
                  className="text-[11px] px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-slate-700 hover:bg-slate-50 transition shadow-sm"
                >
                  Copier l'objet
                </button>
                <button
                  type="button"
                  onClick={() => copyToClipboard(body, "Corps du mail copié.")}
                  className="text-[11px] px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 rounded-lg text-white shadow-sm transition"
                >
                  Copier le corps
                </button>
              </div>
            </div>

            <div className="space-y-2">
              <div>
                <label className="text-[10px] text-slate-500 font-medium block mb-1">Objet</label>
                <input
                  readOnly
                  value={subject}
                  className="w-full text-[12px] bg-white border border-slate-200 rounded-lg px-3 py-2 font-mono text-slate-800 focus:outline-none"
                />
              </div>
              <div>
                <label className="text-[10px] text-slate-500 font-medium block mb-1">Corps du mail</label>
                <textarea
                  readOnly
                  value={body}
                  className="w-full h-56 text-[11px] leading-relaxed bg-white border border-slate-200 rounded-lg p-3 font-mono resize-none text-slate-800 focus:outline-none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}